import { AlertClassColour, ApplicationNames, ConfigSystemParamDefaults, ConfigSystemParams, modalFormValues, msSize } from 'src/app/core/consts';
import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { catchError, Observable, throwError, ReplaySubject } from 'rxjs';
import { CompaniesService } from 'src/app/core/services/utelize/system/company/companies-service';
import { CompanyModalFormComponent } from '../_company/company-modal-form/company-modal-form.component';
import { CompletedModalFormComponent } from 'src/app/forms-modal/_pop-ups/completed-modal-form/completed-modal-form.component';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { DashboardService } from 'src/app/core/services/utelize/general/dashboard-service';
import { DeviceDTO } from 'src/app/core/models/system/device/device.dto';
import { DevicesService } from 'src/app/core/services/utelize/system/device/devices-service';
import { EsimReservationDTO } from 'src/app/core/models/system/reservation/esim-reservation.dto';
import { eDeviceType } from 'src/app/core/enums';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { IdAndDescriptionDTO } from 'src/app/core/interfaces/general/id-description';
import { InviewCompaniesService } from 'src/app/core/services/utelize/inview/inview-companies-service';
import { LastPassKillerService } from 'src/app/core/services/utelize/general/last-pass-killer-service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SystemUserDTO } from 'src/app/core/models/system/user/system-user.dto';
import { TypesDeviceService } from 'src/app/core/services/utelize/system/type/types-device-service';
import { WarningModalFormComponent } from 'src/app/forms-modal/_pop-ups/warning-modal-form/warning-modal-form.component';

@Component({
  selector: 'app-reservation-modal-form',
  templateUrl: './reservation-modal-form.component.html',
  styleUrls: ['./reservation-modal-form.component.scss']
})

export class ReservationModalFormComponent implements AfterViewInit, OnDestroy, OnInit {

  @Input() embeddedFormMode      : boolean | undefined;
  @Input() initialInviewCompanyId: number  | undefined;

  @Output() iccidHasBeenReserved               : EventEmitter<number>=new EventEmitter<number>();
  @Output() reservationESIMFormHasBeenCancelled: EventEmitter<void>  =new EventEmitter<void>();

  @ViewChild('companyModalForm',          { static: false   }) companyModalForm!         : CompanyModalFormComponent;
  @ViewChild('completedModalForm',        { static: false   }) completedModalForm!       : CompletedModalFormComponent;
  @ViewChild('reservationModalFormContent', { static: false }) reservationModalFormContent!: TemplateRef<void>;
  @ViewChild('warningModalForm',          { static: false   }) warningModalForm!         : WarningModalFormComponent;
  
  get modalBackGround()               { let value: string | boolean=this.configSystemService.getValue(ConfigSystemParams.ModalBackGround, "TRUE");
                                        return value=value.toUpperCase()=="STATIC" ? "static"     : (value.toUpperCase()=="TRUE" ? true : false) }
  
  private completedOrderStatus          : string="Reserved";
  private device                        : DeviceDTO | undefined;
  private deviceIdData!                 : IdAndDescriptionDTO[];
  private deviceTypeIdData!             : IdAndDescriptionDTO[];
  private initialInviewCompanyIdSet     : boolean=false;
  private initialSelectedDeviceIdSet    : boolean=false;
  private initialSelectedDeviceTypeIdSet: boolean=false;
  private initialStatus                 : string="Please complete the following details";
  private initialOrderStatus            : string="Pending";
  private inviewCompanyIdData!          : IdAndDescriptionDTO[];
  private productIdData!                : IdAndDescriptionDTO[];
  private selectedDeviceId              : number=-1;
  private selectedDeviceTypeId          : number=-1;
  private selectedInviewCompany?        : IdAndDescriptionDTO;
  private statusCheck                   : ReplaySubject<boolean> = new ReplaySubject(1);
  private sureSimCompanyId              : number | undefined;

  public reservationForm!               : UntypedFormGroup;
  public addCompanyButtonEnabled        : boolean=true;
  public addUserButtonEnabled           : boolean=false;
  public alertColourOrderStatus         : string=AlertClassColour.Grey;
  public alertColourProgress            : string=AlertClassColour.Grey;
  public breadCrumbItems!               : Array<{}>;
  public curUser                        : SystemUserDTO;
  //public exsitingReservedSimsCount      : number | undefined;
  public formSubmitted                  : boolean=false;
  public formTitle                      : string="SureSIM Reservations";
  //public maxReservationsAllowed         : number | undefined;
  public orderStatusInformation         : string=this.initialOrderStatus;
  //public remainingReservationsAllowed   : number=0;
  public reservationButtonEnabled       : boolean=false;
  public reservationInProgress          : boolean=false;
  public progressInformation            : string=this.initialStatus;
  public registerInviewCompany          : boolean=false;
  public selectedICCID                  : string="";
  public selectedInviewCompanyId        : number | undefined;
  public warningMessageMain             : string | undefined;
  public warningMessageSub              : string | undefined;

  constructor(
    private authenticationService : AuthenticationService,
    private companiesService      : CompaniesService,
    private configSystemService   : ConfigSystemService,
    private exceptionsService     : ExceptionsService,
    private dashboardService      : DashboardService,
    private devicesService        : DevicesService,
    private formBuilder           : UntypedFormBuilder,
    private inviewCompaniesService: InviewCompaniesService,
    private lastPassKillerService : LastPassKillerService,
    private modalService          : NgbModal,
    private typesDeviceService    : TypesDeviceService,
  ) {
    this.curUser=this.authenticationService.currentUserObject();
  }

  public ngOnInit(): void {
    try {

    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngAfterViewInit(): void {
    try {
      this.lastPassKillerService.start();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngOnDestroy() {
    try {
      this.lastPassKillerService.stop();
      this.closeForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public closeForm(): void {
    try {
      this.statusCheck.next(true);
      this.statusCheck.complete();
      this.reservationESIMFormHasBeenCancelled.emit();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public resetMainVariables(IsFormOpening : boolean): void {
    try {
      this.addCompanyButtonEnabled        =true;
      this.addUserButtonEnabled           =false;
      this.alertColourProgress            =AlertClassColour.Grey;
      this.formSubmitted                  =false;
      this.initialSelectedDeviceIdSet     =false;
      this.initialSelectedDeviceTypeIdSet =false;
      this.progressInformation            =this.initialStatus;
      this.reservationButtonEnabled       =(this.selectedICCID != "");
      this.registerInviewCompany          =false;
      this.selectedInviewCompanyId        =undefined;
      //this.updateReservationStatus(this.initialOrderStatus, false);

      if (IsFormOpening)
      {
         this.initialInviewCompanyIdSet   =false;
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public openForm(iccid :string, deviceTypeId :number, existingReservedSimCount :number, maxReservations :number): void {
    try {
      //this.exsitingReservedSimsCount    =existingReservedSimCount;
      //this.maxReservationsAllowed       =maxReservations;
      //this.remainingReservationsAllowed =maxReservations - existingReservedSimCount;
      this.selectedICCID                =iccid;
      this.selectedDeviceTypeId         =deviceTypeId;
      this.startProcess();
      this.openModal();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private openModal(): void {
    try {
      this.modalService.open(this.reservationModalFormContent, { backdrop: this.modalBackGround, 
                                                                 centered: true,
                                                                 keyboard: false,
                                                                 size    : msSize.Large });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private startProcess(): void {
    try {
      this.resetMainVariables(true);
      this.refreshInviewCompanyData();
      //if (this.selectedICCID == "") {
        this.refreshDeviceTypeData();
      //}
      this.setUpForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region reservationForm

  get formData() {
    return this.reservationForm.controls;
  }

  private setUpForm() {
    try {
      this.getDevice();
      this.buildForm();
      this.enableDisableControls(true);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private buildForm() {
    try {
      this.reservationForm=this.formBuilder.group({ });

      this.addFormFields(this.reservationForm);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private addFormFields(formGroup: UntypedFormGroup) {
    try {
      let defaultReservationNumber = this.selectedICCID != "" ? "1" : "";
      if (formGroup==this.reservationForm) {
        this.addFormControl(formGroup, "deviceId",          ""                      , []);
        this.addFormControl(formGroup, "deviceTypeId",      ""                      , [Validators.required]);
        this.addFormControl(formGroup, "iccid",             ""                      , []);
        this.addFormControl(formGroup, "inviewCompanyId",   ""                      , [Validators.required]);
        this.addFormControl(formGroup, "reservationNumber", defaultReservationNumber, [Validators.required, Validators.min(1), Validators.pattern('^[0-9]*$')]); // , Validators.max(this.remainingReservationsAllowed)
        this.addFormControl(formGroup, "orderGuid",         crypto.randomUUID()     , [])
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private addFormControl(form      : UntypedFormGroup,
                         dataField : string,
                         value     : string,
                         validators: Validators) {
    try {
      form.addControl(dataField, new FormControl(
        value,
        validators
      ));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private removeFormFields(form: UntypedFormGroup) {
    try {
      if (form != undefined) {
        for (let control in form.controls) {
          form.removeControl(control);
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public saveFormData() {
    try {
      this.formSubmitted=true;
      
      if (this.reservationForm.valid) {
        let esimReservationDTO: EsimReservationDTO={
          deviceId        : this.reservationForm.controls["deviceId"].value,
          deviceTypeId    : this.reservationForm.controls["deviceTypeId"].value,
          iccid           : this.reservationForm.controls["iccid"].value,
          inviewCompanyId : this.reservationForm.controls["inviewCompanyId"].value,
          numberToReserve : this.reservationForm.controls["reservationNumber"].value,
          orderGuid       : this.reservationForm.controls["orderGuid"].value
        }

        this.doReservation(esimReservationDTO);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private enableDisableControls(enabled: boolean) {
    try {
      
      this.addUserButtonEnabled    =enabled;
      this.reservationButtonEnabled=enabled;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private disableAllControls() {
    try {
      this.reservationForm.controls["deviceTypeId"].disable();
      this.reservationForm.controls["iccid"].disable();
      this.reservationForm.controls["inviewCompanyId"].disable();
      this.reservationForm.controls["reservationNumber"].disable();
      
      this.addCompanyButtonEnabled =false;
      this.addUserButtonEnabled    =false;
      this.reservationButtonEnabled=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  //#endregion

  //#region Device

  public getDevice() {
    this.device= <DeviceDTO>{id:0, imeiIccid:"TBD", supplierID:1, allocated:false, active:true, enteredBy:1, batchID:0, defaultProductID:0, deviceTypeID:1,msisdn:"",reservedCompanyID:0};
  }

  public allocateDevice() {
    try {
      if (this.device != undefined && this.device.id>0) {
        this.devicesService.allocate(this.device.id)
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {

          },
          error: error => {
            this.exceptionsService.handleException(new Error(error));
          }
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Dropdown Arrays

  public getDropdownDataObjectArray(fieldName: string) {
    try {
      if (fieldName=="inviewCompanyId") {
        return this.inviewCompanyIdData;

      } else if (fieldName=="deviceId") {
        return this.deviceIdData;

      } else if (fieldName=="deviceTypeId") {
        return this.deviceTypeIdData;

      } else if (fieldName=="productId") {
        return this.productIdData;
      }

      return undefined;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return undefined;
    }
  }


  private getDropdownData(dataSource: Observable<any>, fieldName: string) {
    try {
      if (dataSource) {
        dataSource
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            if (fieldName=="inviewCompanyId") {
              this.inviewCompanyIdData=(data as IdAndDescriptionDTO[]);

              if (!this.initialInviewCompanyIdSet && this.initialInviewCompanyId != undefined && this.initialInviewCompanyId>0) {
                this.reservationForm.controls["inviewCompanyId"].setValue(this.initialInviewCompanyId);
                
                this.initialInviewCompanyIdSet=true;
              }

              this.inviewCompanySelectDropDownChange(undefined);

            } else if (fieldName=="deviceId") {
              this.deviceIdData=(data as IdAndDescriptionDTO[]);

              if (!this.initialSelectedDeviceIdSet && this.selectedICCID != undefined && this.selectedICCID!="") {
                this.selectedDeviceId = <number>this.deviceIdData.find(x => x.description==this.selectedICCID)?.id ?? -1;

                this.reservationForm.controls["deviceId"].setValue(this.selectedDeviceId);
                this.reservationForm.controls["iccid"].setValue(this.selectedICCID);

                this.initialSelectedDeviceIdSet=true;
              }

            } else if (fieldName=="deviceTypeId") {
              this.deviceTypeIdData=(data as IdAndDescriptionDTO[]);

              if (!this.initialSelectedDeviceTypeIdSet && this.selectedDeviceTypeId != undefined && this.selectedDeviceTypeId>0) {
                this.reservationForm.controls["deviceTypeId"].setValue(this.selectedDeviceTypeId);
                this.reservationForm.controls["deviceTypeId"].disable();
                this.refreshDeviceData();

                this.initialSelectedDeviceTypeIdSet=true;
              }

            } else if (fieldName=="productId") {
              this.productIdData=(data as IdAndDescriptionDTO[]);
              if (this.productIdData.length == 1) {
                this.reservationForm.controls["productId"].setValue(this.productIdData[0].id);
              }
            } 
           },
          error: error => {
            this.exceptionsService.handleException(new Error(error));
          }
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Inview Company
  
  public refreshInviewCompanyData() {
    try {
      this.getDropdownData(this.inviewCompaniesService.getIdAndDescription(this.curUser.inviewUserId), "inviewCompanyId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public deviceSelectDropDownChange(event: Event | undefined) {
    try {
      let deviceId=this.reservationForm.controls["deviceId"].value;

      if (isNaN(deviceId) || deviceId=="") {
        deviceId=-1;
        this.reservationForm.controls["iccid"].setValue("");
      }
      else {
        let iccid = this.deviceIdData.find(x => x.id==this.reservationForm.controls["deviceId"].value)?.description ?? "";
        this.reservationForm.controls["iccid"].setValue(iccid);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public deviceTypeSelectDropDownChange(event: Event | undefined) {
    try {
      let deviceTypeId=this.reservationForm.controls["deviceTypeId"].value;

      if (isNaN(deviceTypeId) || deviceTypeId=="") {
        deviceTypeId=-1;
      }

      let gotDeviceType = deviceTypeId>0;      

      if (gotDeviceType) {
        if (this.selectedICCID != "") {
          this.getDropdownData(this.devicesService.getAvailableIdAndDescription(deviceTypeId, <number>this.sureSimCompanyId, true, false), "deviceId");
        }
        this.reservationButtonEnabled=true;
      };
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public inviewCompanySelectDropDownChange(ev: any) {
    try {
      this.resetMainVariables(false);
      this.enableDisableControls(false);

      this.selectedInviewCompany=this.inviewCompanyIdData.find(x => x.id==this.reservationForm.get('inviewCompanyId')?.value);
      let gotCompany            =this.selectedInviewCompany?.id!=undefined && <number>this.selectedInviewCompany?.id>0;      

      if (gotCompany) {
        this.selectedInviewCompanyId=<number>this.selectedInviewCompany?.id;

        this.companiesService.getIdByCompanyName(this.selectedInviewCompany?.description ?? "")
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            this.sureSimCompanyId=data.result;
            this.refreshReservationCount(this.initialOrderStatus);
            if (this.sureSimCompanyId<=0) {
              this.registerInviewCompany=true;
              this.alertColourProgress  =AlertClassColour.Red;
              this.progressInformation  =`${this.selectedInviewCompany?.description} is not ${ApplicationNames.eSimPlatform} registered`;
              this.warningMessageMain   ="Company not registered";
              this.warningMessageSub    =`The selected company is not registered on the ${ApplicationNames.eSimPlatform} and must be registered before continuing`;
              
              this.warningModalForm.openForm(this.warningMessageMain, this.warningMessageSub);

            } else {
              this.enableDisableControls(true);

              this.progressInformation=`${this.selectedInviewCompany?.description} is ${ApplicationNames.eSimPlatform} registered`;
              this.alertColourProgress=AlertClassColour.Green;
            }

            // if (this.selectedICCID != "") {
            //   this.refreshDeviceTypeData();
            // }
          },
          error: error => {
            this.exceptionsService.handleException(new Error(error));
          }
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public addInviewCompany() {
    try {
      if (this.registerInviewCompany) {
        this.selectedInviewCompanyId=<undefined>this.selectedInviewCompany?.id;

      } else {
        this.selectedInviewCompanyId=modalFormValues.createNewCompanyId;
      }

      this.companyModalForm.openForm(0);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public inviewCompanyHasBeenSaved(inviewCompanyId: number | undefined) {
    try {
      if (inviewCompanyId != undefined && inviewCompanyId>0) {
        this.registerInviewCompany=false;

        this.reservationForm.controls["inviewCompanyId"].setValue(inviewCompanyId);
        
        this.refreshInviewCompanyData();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion
                                           
  //#endregion

  //#endregion

  //#region SureSIM Product

  public refreshDeviceData() {
    try {
      this.getDropdownData(this.devicesService.getAvailableIdAndDescription(this.selectedDeviceTypeId, <number>this.sureSimCompanyId ?? -1, false, true), "deviceId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public refreshDeviceTypeData() {
    try {
      this.getDropdownData(this.typesDeviceService.getIdAndDescription(), "deviceTypeId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Reservation

  private addCustomError(controlName: string, errorKey: string, errorValue: any) {
    const control = this.reservationForm.get(controlName);
    if (control) {
      control.setErrors({ ...control.errors, [errorKey]: errorValue });
    }
  }
  
  private doReservation(esimReservationDTO : EsimReservationDTO): void {
    try {
      this.reservationInProgress = true;

      this.devicesService.reserveNextAvailableDevice(esimReservationDTO)
      .pipe(
        catchError((error) => {
          this.reservationInProgress = false;
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.device=data;

          //this.exsitingReservedSimsCount = Number(this.exsitingReservedSimsCount ?? 0) + Number(esimReservationDTO.numberToReserve);
          //this.remainingReservationsAllowed = Number(this.maxReservationsAllowed) - Number(this.exsitingReservedSimsCount);
          this.orderStatusInformation = this.completedOrderStatus;
          //this.updateReservationStatus(this.orderStatusInformation, true);

          this.reservationInProgress = false;
          this.processComplete();
        },
        error: error => {
          if (error.message && error.message.includes("404")) {
            this.reservationInProgress = false;
            this.enableDisableControls(false);

            this.warningMessageMain="There are no eSIMs available";
            this.warningMessageSub ="Please contact the application vendor for assistance";

            this.warningModalForm.openForm(this.warningMessageMain, this.warningMessageSub);
          } else if (error.message && error.message.includes("Failed searching for next available sim")) {
            this.reservationInProgress  = false;
            this.enableDisableControls(true);
            this.addCustomError('deviceId', 'alreadyReserved', 'Please select different ICCID, this one is no longer available');

          } else {
            this.reservationInProgress = false;
            this.exceptionsService.handleException(new Error(error));
          }
        }
      });
    }
    catch(e) {
      this.reservationInProgress = false;
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Process Complete

  private processComplete() {
    try {
      var deviceType = "eSIM";
      if (this.reservationForm.controls["deviceTypeId"].value != eDeviceType.esim) {
        deviceType = "SIM";
      }

      var message = "The " + deviceType + " has been reserved";
      if (this.reservationForm.controls["reservationNumber"].value > 1) {
        message = "The " + deviceType + "s have been reserved";
      }

      this.completedModalForm.openForm("Congratulations", message);
      this.iccidHasBeenReserved.emit(this.reservationForm.controls["deviceTypeId"].value);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public completedModalHasBeenClosed() {
    try {
      if (this.embeddedFormMode) {
        this.selectedDeviceTypeId = -1;
        this.selectedDeviceId     = -1;
        this.selectedICCID        = "";
        this.startProcess();
      } else {
        this.disableAllControls();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public getTotalReservedeSimCount() {
    try {
      this.dashboardService.getTotalReservedeSimCount(this.sureSimCompanyId  ?? -1, 2025, 1, 1)
                                                      // <number>this.filterDate.year,
                                                      // <number>this.filterDate.month,
                                                      // <number>this.filterDate.day)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
            //this.exsitingReservedSimsCount    = Number(this.exsitingReservedSimsCount ?? 0) +  Number(data.currentTotal);
            //this.remainingReservationsAllowed = Number(this.maxReservationsAllowed) - Number(this.exsitingReservedSimsCount);
            this.getTotalReservedSimCount();
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public getTotalReservedSimCount() {
    try {
      this.dashboardService.getTotalReservedSimCount(this.sureSimCompanyId  ?? -1, 2025, 1, 1)
                                                    //  <number>this.filterDate.year,
                                                    //  <number>this.filterDate.month,
                                                    //  <number>this.filterDate.day)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
            //this.exsitingReservedSimsCount    = Number(this.exsitingReservedSimsCount ?? 0) + Number(data.currentTotal);
            //this.remainingReservationsAllowed = Number(this.maxReservationsAllowed) - Number(this.exsitingReservedSimsCount);
            this.orderStatusInformation    = this.initialOrderStatus;
            //this.updateReservationStatus(this.orderStatusInformation, true);
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public refreshReservationCount(status:string) {
    try {
      //this.exsitingReservedSimsCount = 0;
      this.getTotalReservedeSimCount();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  // public updateReservationStatus(status:string, includeSimReservationInfo:boolean) {
  //   try {
  //     if (includeSimReservationInfo == true) {
  //       this.orderStatusInformation = status + `  (You currently have ${this.exsitingReservedSimsCount} reserved sims, the maximum allowed is ${this.maxReservationsAllowed})`;
  //     } else {
  //       this.orderStatusInformation = status;
  //     }


  //   }
  //   catch(e) {
  //     this.exceptionsService.handleException(<Error>e);
  //   }
  // }

  //#endregion
}
